/**
 * @module
 */

/**
 * @import {UserProfileData} from '../model/user-profile.js'
 */

import {service, reactive} from 'nova';
import {COMPILE, SCOPE} from '@acng/frontend-stargazer';

import userDummySrc from '../../../basic/img/noImg.png';
import {asset, make, media} from '../../core/service/env.js';
import {user} from '../user.js';
import {GUEST} from '../model/dictionary.js';
import {ProfileChange} from './change.js';
import {Preference} from './preference.js';
import {UserProfileApi} from '../../api/user-profile.js';
import {UserImageUpload} from './image/upload.js';

/**
 * Change user profile
 */
@service
class UserProfile extends UserProfileApi {
  DEBUG = true;
  [SCOPE] = this;
  change = new ProfileChange(this);
  preference = new Preference(this, 'preference');
  experience = new Preference(this, 'experience');
  lookingfor = new Preference(this, 'lookingfor');
  @reactive accessor male = false;
  @reactive accessor female = false;
  imageUpload = make(UserImageUpload);
  @reactive accessor image = asset(userDummySrc);

  [COMPILE]() {
    if (user[GUEST]) {
      this.flush();

      return null;
    }

    return this.setup();
  }

  /**
   * 1. Make sure the profile data is loaded.
   * 2. Set the reactive properties.
   *
   * @returns {Promise<UserProfileData>}
   *
   * @todo
   *
   *   - Check why this is called twice when reloading on the user profile page.
   */
  async setup() {
    const data = await super.get();
    const images = data?.images;

    this.male = data.gender == 'm';
    this.female = data.gender == 'f';
    this.image = images ? media.user + images.wide[900] : asset(userDummySrc);

    return data;
  }
}

export {UserProfile};
